import { createContext } from 'react'

import { ViewportPageContextType } from './types'

export const ViewportPageContext = createContext<ViewportPageContextType>(
  {} as ViewportPageContextType,
)
